import { render, staticRenderFns } from "./CoursesInProgressSection.vue?vue&type=template&id=51f93141&scoped=true"
import script from "./CoursesInProgressSection.vue?vue&type=script&lang=js"
export * from "./CoursesInProgressSection.vue?vue&type=script&lang=js"
import style0 from "./CoursesInProgressSection.vue?vue&type=style&index=0&id=51f93141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f93141",
  null
  
)

export default component.exports